import column from './column/column.component';
import component from './flows.component';
import contact from './contact/contact.component';
import service from './flows.service';
import updateDonations from './updateDonations/updateDonations.controller';

export default angular.module('mpdx.tools.appeals.flows', [component, column, contact, service, updateDonations]).name;
